import React, { useState } from 'react';
import noImage from '../slike/noImage.png';
import { formatPrice } from '../../../../../utils/FormatPrice';
import { useTranslation } from 'react-i18next';

const DetailView = ({ item, handleSaveNumber, quantity, setQuantity }) => {
  const { t, i18n } = useTranslation();
  const increment = () => {
    setQuantity(quantity + 1);
  };

  const decrement = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };
  console.log('item detalji', item);
  return (
    <div className="detail-view">
      <div style={{ display: 'flex' }}>
        <div className="detail-view-image">
          <img src={item.slikaUrl || noImage} alt="slika" />
        </div>
        <div className="detail-view-details">
          <div
            style={{ display: 'flex', gap: '10px', flexDirection: 'column' }}
          >
            <h2>{item.naziv}</h2>
            <p>
              <strong>{t('partNumber')}:</strong> {item.partNumber}
            </p>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                gap: '10px',
              }}
            >
              {item.rabat !== 0 && (
                <div>
                  <div style={{ display: 'flex', gap: '5px' }}>
                    <div
                      style={{
                        backgroundColor: '#e00',
                        borderRadius: '4px',
                        color: '#fff',
                        width: '40px',
                        height: '20px',
                        textAlign: 'center',
                      }}
                    >
                      {item.rabat}%
                    </div>{' '}
                    <div style={{ fontWeight: 'bold', color: '#e00' }}>
                      <span style={{ fontWeight: '100' }}>{t('saving')}:</span>{' '}
                      {formatPrice(item.usteda)}{' '}
                      <span style={{ fontSize: '15px' }}>EUR</span>
                    </div>
                  </div>
                  <div
                    style={{
                      color: '#a0a0a0',
                      textDecoration: 'line-through',
                    }}
                  >
                    {formatPrice(item.prodajnaCena)}{' '}
                    <span style={{ fontSize: '15px' }}>EUR</span>
                  </div>
                </div>
              )}
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <h3 style={{ margin: '3px' }}>
                  {formatPrice(item.fakturnaCena)}
                </h3>{' '}
                <span style={{ color: 'gray', fontWeight: '600' }}>EUR</span>
              </div>
              <div className="cart-item-quantity">
                <button
                  className="quantity-button"
                  style={{ paddingBottom: '6px' }}
                  onClick={decrement}
                >
                  -
                </button>
                <span className="quantity">{quantity}</span>
                <button className="quantity-button" onClick={increment}>
                  +
                </button>
              </div>
              <p style={{ fontWeight: 'bold' }}>
                {formatPrice(item.fakturnaCena * +quantity)} EUR
              </p>
            </div>
          </div>
          <div className="btn-save" onClick={(e) => handleSaveNumber(e, item)}>
            {' '}
            {t('buttons.addToCart')}
          </div>
        </div>
      </div>
      <div className="detail-view-description">
        <p style={{ fontWeight: 'bold', fontSize: '20px' }}>
          {t('description')}
        </p>
        <p>{item.opis} </p>
      </div>
    </div>
  );
};

export default DetailView;
